export default "__VITE_ASSET__c7dc2cdd__"